import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui'

import baiduMap from 'vue-baidu-map'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(baiduMap,{
	ak:'unYfG5P3FpkplH7QMtSC2HEwDK2S12BG'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
